﻿<template>
    <section class="mb-card">
        <div class="mb-card-body">
            <h3 class="mb-card-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
                </svg>
                Documentation
                <span class="mb-count" v-if="($store.getters.get_Booking?.documents?.length ?? 0) > 0">{{ $store.getters.get_Booking.documents.length }}</span>
            </h3>

            <div class="bd-docs" v-if="($store.getters.get_Booking?.documents?.length ?? 0) > 0">
                <a
                    v-for="document in $store.getters.get_Booking.documents"
                    :key="document.id || document.name"
                    :href="document.url"
                    target="_blank"
                    rel="noopener"
                    class="bd-doc"
                    :title="document.name"
                >
                    <span class="bd-doc-icon" aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" />
                        </svg>
                    </span>
                    <span class="min-w-0">
                        <span class="bd-doc-name">{{ document.name }}</span>
                        <span class="bd-doc-action">View PDF ↗</span>
                    </span>
                </a>
            </div>
            <div class="mb-empty" v-else>
                <span>No documents are available for this booking yet.</span>
            </div>
        </div>
    </section>
</template>
<script lang="ts" src="./booking_documentation.ts"></script>
